import type { SimulationState } from '../game/types'
import { buildProximityContacts } from './proximity-model'
import './proximity-radar.css'

export function ProximityRadar({ state }: { state: SimulationState }) {
  const contacts = buildProximityContacts(state)
  const nearest = contacts[0]
  if (!nearest) return null
  return (
    <aside className="proximity-radar" aria-label="Nearby racers">
      <div className="proximity-radar__scope" aria-hidden="true">
        <i />
        {contacts.map((contact) => (
          <span
            key={contact.vehicleId}
            data-fire={contact.inFireWindow || undefined}
            style={{ transform: `rotate(${contact.relativeAngle}rad) translateY(-2.35rem)` }}
          />
        ))}
      </div>
      <div className="proximity-radar__readout" data-fire={nearest.inFireWindow || undefined}>
        <small>{nearest.inFireWindow ? 'FIRE WINDOW' : `NEAREST // ${nearest.direction}`}</small>
        <strong>{nearest.name}</strong>
        <span>
          {Math.round(nearest.distance)} M {' · '}
          {nearest.closingSpeed >= 0 ? 'CLOSING' : 'OPENING'} {Math.round(Math.abs(nearest.closingSpeed) * 3.6)} KM/H
        </span>
      </div>
    </aside>
  )
}
